import { RegisterAgentComponent } from './register-agent/register-agent.component';
import { HowToVerifyIndentityComponent } from './how-to-verify-identity/how-to.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { OurServicesComponent } from './our-services/our-services.component';
import { OurAgentsComponent } from './our-agents/our-agents.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'how-to-verify-identity',
        component: HowToVerifyIndentityComponent,
      },
      { path: 'services', component: OurServicesComponent },
      { path: 'our-agents', component: OurAgentsComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'register-agent', component: RegisterAgentComponent },
      { path: 'login', component: LoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      // { path: 'term-of-use', component: TermUseComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule {}
